// import { useLogout } from 'app/core/api/auth/api-auth';
import {
  useIdentity,
  useUpdateCurrentCompany,
} from 'app/core/api/company/api-company';
import AppImage from 'app/shared/components/app-image/AppImage';
import Button from 'app/shared/components/button/Button';
import Icon from 'app/shared/components/icon/Icon';
import IconLib from 'app/shared/components/icon/icon-lib';
import { DefaultUserImg } from 'app/shared/components/misc';
import { useShowInfo } from 'app/shared/context-hooks/use-show-info.hook';
import styledFuncs from 'app/styles/styledFuncs';
import React, { useRef } from 'react';
// import { useDispatch } from 'react-redux';
import styled from 'styled-components/macro';
import ReactStars from 'react-rating-stars-component';

const ProfileHeaderContainer = styled.div`
  color: white;
  position: relative;
  display: flex;
`;

const ProfileRemoveButton = styled(Button)`
  position: absolute;
  padding: ${styledFuncs.pad()};
  min-width: 30px;
  min-height: 30px;
  top: 0px;
  right: 0px;
  border-radius: 50%;
  z-index: 1;
`;

const ProfileEditButton = styled(Button)`
  position: absolute;
  padding: ${styledFuncs.pad()};
  min-width: 30px;
  min-height: 30px;
  bottom: 10px;
  right: 0px;
  border-radius: 50%;
`;

export default function ProfileHeader(): JSX.Element {
  const { showSnack } = useShowInfo();

  // const { resource: { company, user } = {} } = useIdentity();
  const { resource: { company, user } = {}, request: refresh } =
    useIdentity();
  // const { request$: logout$, sending: loggingOut } = useLogout();
  const { request$: updateCompany$ } = useUpdateCurrentCompany();

  const fileRef = useRef<HTMLInputElement>(null);
  const [uploadImgUrl, setUploadImgUrl] = React.useState('');

  const onSelectPhoto = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { files } = e.target;
    const successMsg = 'Profile image successfully updated!';
    const failureMsg = 'Error updating profile image';

    if (files?.[0]) {
      updateCompany$({ logo: files[0] }).subscribe({
        next: () => {
          refresh();
          setUploadImgUrl(URL.createObjectURL(files[0]));
          showSnack({ message: successMsg });
        },
        error: () => {
          setUploadImgUrl('');
          showSnack({ message: failureMsg, alertType: 'error' });
        },
      });
    }
  };
  const onRemovePhoto = () => {
    const successMsg = 'Profile image remove successfully';
    const failureMsg = 'Error updating profile image';
    updateCompany$({ logo: null }).subscribe({
      next: () => {
        setUploadImgUrl('');
        refresh();
        // setUploadImgUrl(URL.createObjectURL(files[0]));
        showSnack({ message: successMsg });
      },
      error: () => {
        setUploadImgUrl('');
        showSnack({ message: failureMsg, alertType: 'error' });
      },
    });
  };

  return (
    <>
      <ProfileHeaderContainer>
        {/* <Heading variant="h5">{company?.displayName}</Heading> */}
        {/* <Button
            height={35}
            disabled={loggingOut}
            onClick={() => {
              logout$().subscribe();
            }}
          >
            Logout
          </Button> */}
        <div className="flex relative">
          <ProfileRemoveButton
            onClick={onRemovePhoto}
            variant="contained"
            color="secondary"
            className="w-3 h-3 border border-white border-solid"
          >
            <Icon icon={IconLib.CROSS} size={18} />
          </ProfileRemoveButton>
          <AppImage
            alt="profile image"
            src={company?.logo ?? uploadImgUrl}
            fallbackImgNode={<DefaultUserImg size={100} />}
            height="100px"
            noPad
            className="overflow-hidden m-1 w-10 h-10 rounded shadow-lg-rm shrink-0"
            classes={{ img: 'object-cover' }}
          />
          {/* <ProfileImgComponent
            height="150px"
              src={company?.logo ?? uploadImgUrl}
              alt="profile image"
              fallbackImgNode={<DefaultUserImg size={150} />}
        /> */}
          <ProfileEditButton
            onClick={() => fileRef.current?.click()}
            variant="contained"
            color="primary"
            className="w-3 h-3 border border-white border-solid"
          >
            <Icon icon={IconLib.EDIT} size={18} />
            <input
              type="file"
              ref={fileRef}
              css="display:none;"
              onChange={onSelectPhoto}
              accept="image/*"
            />
          </ProfileEditButton>
        </div>
        <div className="flex flex-col items-start mt-2 ml-1">
          <div
            className="mb-0.5 text-xl font-semibold line-clamp-2"
            style={{ color: 'black' }}
          >
            {company?.name}
          </div>
          <a
            href={`mailto: ${user?.email ?? ''})`}
            className="text-xs"
          >
            {user?.email}
          </a>
          <div style={{ display: 'flex' }}>
            <div style={{ padding: '7px 3px', color: '#000' }}>
              {company?.rating}
            </div>
            <ReactStars
              count={5}
              // onChange={ratingChanged}
              size={24}
              activeColor="#f9d12"
              value={company?.rating}
              edit={false}
            />
          </div>
        </div>
      </ProfileHeaderContainer>
    </>
  );
}
